<template>
  <div class="content-v2">
    <div class="cases-grid-v2">
      <router-link class="case-card-v2" v-for="item in caseList" :key="item.id" :to="'/cases/debug/' + item.id">
        <div class="case-img-v2">
          <img :src="item.image" :alt="item.title" />
        </div>
        <div class="case-info-v2">
          <h4>{{ item.title }}</h4>
          <p>{{ item.summary }}</p>
          <span class="case-tag">{{ $t('cases.debugTag') }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getCaseList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultCaseImage from '@/assets/images/case1.svg'

export default {
  name: 'CasesDebugV2',
  data() {
    return {
      caseList: Array.from({ length: 6 }).map((_, index) => ({
        id: index + 1,
        title: [
          '印尼莫罗瓦利拉波塔电厂调试项目',
          '青海格尔木光伏与熔盐储能调试项目',
          '广东廉江核电厂用电源系统调试项目',
          '马来西亚Cypark垃圾焚烧发电项目',
          '国家能源集团霍州电厂供热改造项目',
          '塞浦路斯麦瑞260MW联合循环电站项目'
        ][index],
        summary: [
          '5×380MW 发电调试',
          '500MW光伏+50MW熔盐储能',
          '1、2号机组厂用电源系统',
          '1×600t/d+1×19.73MW',
          '2×600MW供热改造调试',
          '260MW联合循环电站'
        ][index],
        image: defaultCaseImage
      }))
    }
  },
  created() {
    getCaseList({ caseType: 'commissioning', pageNum: 1, pageSize: 30 }).then(({ rows }) => {
      if (!rows || !rows.length) {
        return
      }
      this.caseList = rows.map(item => ({
        id: item.caseId,
        title: item.caseTitle,
        summary: item.summary || item.serviceScope || '',
        image: resolveFileUrl(item.coverUrl, defaultCaseImage)
      }))
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
.cases-grid-v2 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.case-card-v2 {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  transition: all 0.4s;
  color: inherit;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(0,0,0,0.1);
  }

  .case-img-v2 {
    height: 200px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s;
    }

    &:hover img {
      transform: scale(1.05);
    }
  }

  .case-info-v2 {
    padding: 24px;

    h4 {
      font-size: 18px;
      font-weight: 600;
      color: #0f172a;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      color: #64748b;
      margin-bottom: 16px;
    }

    .case-tag {
      display: inline-block;
      padding: 4px 14px;
      background: linear-gradient(135deg, #3b82f6, #06b6d4);
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      border-radius: 20px;
    }
  }
}

@media (max-width: 960px) {
  .cases-grid-v2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .cases-grid-v2 {
    grid-template-columns: 1fr;
  }
}
</style>
